import cx from 'clsx';
import { Tag } from '@vechaiui/react';
import { useLocalization } from '@fluent/react';

import { FragmentType, getFragmentData } from '#/__generated__/graphql';
import {
  FreightDeliveryDetailsPanelFragmentDoc,
  OrderStatus,
} from '#/__generated__/graphql/graphql';
import StatusIndicator from '#/components/display/StatusIndicator';
import { getColorByStatus } from '#/utils/order-status';

const FreightDeliveryDetailsPanel: React.FC<FreightDeliveryDetailsPanelProps> = ({
  className,
  companyName,
  freightDelivery: _freightDelivery,
  status,
}) => {
  const { l10n } = useLocalization();
  const freightDelivery = getFragmentData(FreightDeliveryDetailsPanelFragmentDoc, _freightDelivery);
  const isDeliveryOnTime = freightDelivery?.expectedArrivalDate
    ? new Date(freightDelivery.expectedArrivalDate) > new Date()
    : undefined;

  return (
    <div className={cx(className, 'rounded-xl border')}>
      <header className="bg-white px-4 rounded-t-xl">
        <div className="border-b flex items-center gap-6 justify-between py-3">
          <span className="label">{l10n.getString('trip-quick-view')}</span>

          <div className="flex items-center gap-4">
            {status === OrderStatus.OrderInTransit && isDeliveryOnTime && (
              <StatusIndicator color="green" text="ON TIME" />
            )}

            <div>
              {/* FIXME: This should get the delivery status? */}
              <Tag
                color={getColorByStatus(status)}
                variant="solid"
                className="uppercase rounded-lg tracking-wider font-bold"
              >
                {l10n.getString(status)}
              </Tag>
            </div>
          </div>
        </div>
      </header>

      {!freightDelivery && (
        <div className="h-24 px-4 bg-neutral-100 rounded-b-2xl flex text-center justify-center items-center">
          <p className="text-neutral-400">{l10n.getString('empty-information-message')}</p>
        </div>
      )}

      {freightDelivery && (
        <div className="bg-white rounded-b-xl py-3 px-4 grid grid-cols-2 divide-x">
          <div className="flex gap-4">
            {/* <div className="relative">
              <Avatar src={''} className="w-20 h-20" />
              <Badge
                color="green"
                variant="solid"
                className="w-5 h-5 p-0 absolute mb-3 right-0 bottom-0 -mr-1"
              >
                <Icon as={CheckIcon} className="w-4 h-4 text-white" label="check" />
              </Badge>
            </div> */}

            <InfoItem label={l10n.getString('driver')}>
              <span className="block text-lg">{freightDelivery.driver}</span>
              <span className="text-sm text-neutral-500 block">{companyName}</span>
            </InfoItem>
          </div>

          <div className="grid grid-cols-12 divide-x">
            <InfoItem className="col-span-7 px-4" label={l10n.getString('vehicle')}>
              <span className="text-sm text-neutral-500 block mt-1">
                {freightDelivery.vehicle.name}
              </span>
            </InfoItem>

            {/*
            <InfoItem className="col-span-5 px-4" label={l10n.getString('estimated-arrival')}>
              <span className="block text-lg">
                {freightDelivery?.expectedArrivalDate &&
                  formatDate(freightDelivery.expectedArrivalDate, { dateStyle: 'medium' })}
              </span>
              <span className="text-sm text-neutral-500 block">
                {freightDelivery?.expectedArrivalDate &&
                  formatDate(new Date(freightDelivery.expectedArrivalDate), { timeStyle: 'short' })}
              </span>
            </InfoItem>
            */}
          </div>
        </div>
      )}
    </div>
  );
};
export type FreightDeliveryDetailsPanelProps = {
  className?: string;
  companyName?: string;
  freightDelivery?: FragmentType<typeof FreightDeliveryDetailsPanelFragmentDoc>;
  status: OrderStatus;
};

const InfoItem: React.FC<InfoItemProps> = ({ className, label, children }) => (
  <div className={className}>
    <span className="label mb-2">{label}</span>
    <span className="block">{children}</span>
  </div>
);
type InfoItemProps = { className?: string; label: string };

export default FreightDeliveryDetailsPanel;
